import { Typography } from '@mui/material';
import axios from 'axios'
import React, { useEffect, useState } from 'react';
import AppCard from "../components/AppCard";
import { model, fblink } from '../config/config';

function Apps() {
 
  const [content, setContent] = useState([]);
 

  const fetchApps = async () => {
    const { data } = await axios.get(
      `${fblink}/apps/${model}.json`
    );
	
    setContent(data);
	
  }
  useEffect(() => {
    fetchApps();
  }, [])
  
  return (
    <div className='container' style={{ padding: "64px 1vw 64px 1vw" }}>
      <Typography variant="h4" component="h4" mb={4}>
       Amazfit {model.toUpperCase()} Application
      </Typography>
	
	{ content.length !== 0 ?	
      (<div className="card-grid">
        {
          content && content.map(item => {
            return <AppCard key={item.fileid} {...item} binfile="apps" />
          })
        }
      </div>)
	  :
	  (
	  <Typography variant="h5" component="h6" mb={4}>
       
      </Typography>
	)
	}
      
    </div>
  )
}

export default Apps